import React from 'react';

import SourceBox from '../SourceBox';

import fetchContent from '../../helpers/backend-communication';
import { addThousandSeparator } from '../../helpers/format';

const columns = [
  {key: 'commodity', label: 'Small Arms'},
  {key: 'Number of Units', label: 'Quantity'},
];

const UNIT_CODE_KEY = "Qty Unit Code"

// Uncomment to show information with respective commodity codes
const commodityTypes = {
//  '1': '',
  '5': 'units',
//  '8': 'kg'
};

class COMTRADEDatabase extends React.Component {
  constructor(props){
    super(props);

    this.state = {
      data: null
    };
  }

  componentDidMount(){
    const countryCode = this.props.countryCode;
    console.log("Fetching content for COMTRADE Sourcebox....");

    fetchContent('comtrade', `?country=${countryCode}`)
      .then(responseObject => {
        this.setState({
          data: this.formatData(responseObject[countryCode])
        });
      })
      .catch( error => {
        console.error("Fetch went wrong", error);
      });
  }

  formatData(data) {
    const newData = {
      import: [],
      export: []
    };

    Object.values(data).forEach(item => {
      const Import = item.Import,
        Export = item.Export;

      if (Import && commodityTypes.hasOwnProperty(Import[UNIT_CODE_KEY])) {
        Import['Number of Units'] = `${addThousandSeparator(Import['Number of Units'])} ` +
          commodityTypes[Import[UNIT_CODE_KEY]];

        newData.import.push(Import);
      }

      if (Export && commodityTypes.hasOwnProperty(Export[UNIT_CODE_KEY])) {
        Export['Number of Units'] = `${addThousandSeparator(Export['Number of Units'])} ` +
          commodityTypes[Export[UNIT_CODE_KEY]];

        newData.export.push(Export);
      }
    });

    return newData;
  }

  buildSections() {
    const data = this.state.data;


    const importSection = { title: 'Import', tables: [] },
      exportSection = { title: 'Export', tables: [] };

    importSection.tables.push({
      data: data.import,
      columns: columns
    });

    exportSection.tables.push({
      data: data.export,
      columns: columns
    });

    return [importSection, exportSection];
  }

  render() {
    if (this.state.data === null) return null;

    const description = (
      <span>
        Source of data: COMTRADE report of <strong>{this.props.countryName} </strong>
        for the calendar year <strong>2024 </strong>
        <a href="https://comtrade.un.org/" target="_blank"> (data source)</a><br></br>
        UN Comtrade HS2012: 9301, 9302, 9303, 9305, 9306
      </span>
    );

    return (
      <SourceBox
        title="COMTRADE"
        logoClass="background-logo-un"
        className="comtrade-table"
        info="The United Nations Commodity Trade Statistics Database (UN Comtrade) stores more than 1 billion trade data records from 1962. Over 140 reporter countries provide the United Nations Statistics Division with their annual international trade statistics detailed by commodities and partner countries. These data are subsequently transformed into the United Nations Statistics Division standard format with consistent coding and valuation using the UN/OECD CoprA internal processing system."
        description={ description }
        hideLargeDescriptions
        sections={ this.buildSections() }
      />
    );
  }
}

export default COMTRADEDatabase



// WEBPACK FOOTER //
// ./src/components/RelatedDatabases/COMTRADEDatabase.js